"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";

interface SidebarNavItem {
  title: string;
  href: string;
}

interface SidebarNavProps {
  items: SidebarNavItem[];
}

export function SidebarNav({ items }: SidebarNavProps) {
  const pathname = usePathname();

  return (
    <nav className="flex flex-row items-center gap-1 lg:flex-col lg:items-stretch">
      {items.map((item) => (
        <Link
          key={item.href}
          href={item.href}
          className={cn(
            "block flex items-center space-x-2 rounded-md px-3 py-2 text-sm font-medium",
            pathname === item.href
              ? "bg-accent text-accent-foreground"
              : "text-muted-foreground transition hover:bg-accent hover:text-accent-foreground",
          )}
        >
          <span>{item.title}</span>
        </Link>
      ))}
    </nav>
  );
}
